import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { getRandomImagesFromGroup } from "../utils/helpers.js";
import { CATEGORIES } from "../utils/constants.js";
import { FONT_SIZES } from "../theme/constants.js";
import { useTranslation } from "react-i18next";

export default function Album() {
	const { t } = useTranslation()

	useEffect(() => {
		const timeout = setTimeout(() => {
		  if (!window.location.hash) {
			window.scrollTo({ top: 0, behavior: "instant" });
		  }
		}, 50); 
	
		return () => clearTimeout(timeout);
	}, []);

	const categoryList = useMemo(() => 
		Object.entries(CATEGORIES).flatMap(([categoryKey, categoryObj]) => {
		  let subcategories = [];
		  if (categoryKey !== 'wood') {
			subcategories = [{
			  categoryKey,
			  subcategories: Object.entries(categoryObj)
				.filter(([_, subcategoryObj]) => subcategoryObj.gallery)
				.map(([subcategoryKey, subcategoryObj]) => ({
				  key: subcategoryKey,
				  images: getRandomImagesFromGroup(subcategoryObj.gallery, 4),
				})),
			}];
		  } else {
			subcategories = Object.entries(categoryObj).map(([subcategoryKey, subcategoryObj]) => ({
			  categoryKey: subcategoryKey,
			  subcategories: subcategoryObj.products.map((product) => ({
				key: product.key,
				images: getRandomImagesFromGroup(product.gallery, 4),
			  })),
			}));
		  }
		  return subcategories;
		})
	  , []);

	const getLink = (category, subcategory) => {
		const categoryParam = category === 'pvc_alu' ? `category=${category}.${subcategory}&` : ''
		const galleryParam = `gallery=${category === 'pvc_alu' ? '' : 'wood.'}${category}.${subcategory}`

		return `/gallery?${categoryParam}${galleryParam}`
	}

	return (
		<div className='album-container container'>
			{categoryList?.map(({ categoryKey, subcategories }) => (
				<section key={categoryKey} className='album-section'>
					<h1 className='section-title' style={{fontSize: FONT_SIZES.titleVLarge}}>{t(`album.${categoryKey}`)}</h1>
					{subcategories?.map(({ key, images }) => (
						<section key={key} className='album-subsection section-link-container'>
							<div className="section-link-target" id={`${categoryKey}-${key}`}/>
							<a className='album-title section-title section-link' href={`#${categoryKey}-${key}`}>
								<span className="section-link-symbol">#</span>{t(`products.${categoryKey}.${key}.title`) !== `products.${categoryKey}.${key}.title` ? t(`products.${categoryKey}.${key}.title`) : t(`album.${key}`)}
							</a>

							<div className='album-grid'>
								{images.map((src, idx) => (
									<img
										key={`${key}-${idx}`}
										src={src}
										alt={`${key}-${idx}`}
										className='album-image'
									/>
								))}
							</div>

							<Link
								className="see-more-link"
								to={getLink(categoryKey, key)}
							>
								{t('interface.seeMore')}
							</Link>
						</section>
					))}
				</section>
			))}
		</div>
	);
}
